export const NAMESPACE = 'reporting'
